import { ofType } from 'redux-observable';
import { share } from 'rxjs/operators';

import type { LightweightEvent, NotificationEvent, Streaming } from './model';

function lightMessagesOfType<R extends NotificationEvent, K extends R['type'] = R['type']>(type: K) {
  return (streaming: Streaming) => streaming.lightEvent$.pipe(ofType(type), share());
}

export const sessionSynchronization = (streaming: Streaming) => streaming.sessionSynchronizationMessage$.pipe(share());

export const getSecondaryMarketMessage$ = (streaming: Streaming) => streaming.secondaryMarketMessage$.pipe(share());

export const getMailStatusMessage$ = (streaming: Streaming) => streaming.mailStatusMessage$.pipe(share());

export const getSecondaryMarketPriceMessage$ = (streaming: Streaming) =>
  streaming.secondaryMarketPriceMessage$.pipe(share());

export const basketAdvisorResult = lightMessagesOfType<LightweightEvent>('NextBasketAdvisorResult');
export const basketOptimizerResult = lightMessagesOfType<LightweightEvent>('NextBasketOptimizerResult');
export const batchQuoteResult = lightMessagesOfType<LightweightEvent>('NewBatchQuoteResult');
export const costsAndCharges = lightMessagesOfType<LightweightEvent>('NextCostsAndCharges');
export const kidDocuments = lightMessagesOfType<LightweightEvent>('NextKidDoc');
export const dynamicQuoteResult = lightMessagesOfType<LightweightEvent>('NextDynamicQuoteResult');
export const staticQuoteResult = lightMessagesOfType<LightweightEvent>('NextQuoteResult');
export const productGovernanceAssessment = lightMessagesOfType<LightweightEvent>('NextPgDocAss');
export const productGovernanceDocument = lightMessagesOfType<LightweightEvent>('NextPgGovDoc');
export const tradeAuthorization = lightMessagesOfType<LightweightEvent>('NextTradeAuth');
export const tradeExecutionReport = lightMessagesOfType<LightweightEvent>('NextTradeExec');
export const productModificationResult = lightMessagesOfType<LightweightEvent>('NextProductModificationResult');
export const ordersBasketQuoteResult = lightMessagesOfType<LightweightEvent>('OrdersBasketQuoteResult');
export const ordersBasketExecutionResult = lightMessagesOfType<LightweightEvent>('OrdersBasketExecutionResult');
export const addonQuoteResult = lightMessagesOfType<LightweightEvent>('NextAddonQuoteResult');
export const addonManagementQuoteResult = lightMessagesOfType<LightweightEvent>('AddonManagementQuoteResult');
